import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { APP_VERSION, DEVELOPMENT, PRODUCTION, PRELIVE } from '@constants/system';
import { StoreInstance } from 'src/stores';

const isPrelive = window.location.host.includes('prelive.honeywood.io');
const bugsnagClient = Bugsnag.start({
  apiKey: 'e0af2c6c3c1a8d7d5fcfdc74991bbf9f',
  plugins: [new BugsnagPluginReact()],
  releaseStage: isPrelive ? PRELIVE : process.env.REACT_APP_STAGE || DEVELOPMENT,
  enabledReleaseStages: [PRODUCTION, DEVELOPMENT, PRELIVE],
  appVersion: APP_VERSION
});

export const ErrorBoundary = bugsnagClient.getPlugin('react').createErrorBoundary(React);

const Logger = {
  error(e) {
    if (process.env.REACT_APP_STAGE !== PRODUCTION) {
      console.log(e);
    }
    Bugsnag.notify(e);
  },
  /** @not use */
  info(...args) {
    console.log(args);
  },
  /** @not use */
  infoMain(arg, useInProduction = false) {
    if (process.env.REACT_APP_STAGE !== PRODUCTION) {
      console.log(`${arg} >> `, arg);
    } else if (useInProduction) {
      this.infoNotify('argument', arg);
    }
  },
  /** @info without bugsnag notify */
  infoMainWithKey(key, ...values) {
    let useInProduction;
    if (
      values.length > 0 &&
      values[values.length - 1] &&
      values[values.length - 1].useInProduction
    ) {
      ({ useInProduction } = values[values.length - 1]);
    }

    if (process.env.REACT_APP_STAGE !== PRODUCTION || useInProduction) {
      if (values.length < 1) {
        console.log(`${key} >> `);
      } else {
        console.log(`${key} >> `, values);
      }
      if (!process.env.REACT_APP_STAGE && StoreInstance.localStackLogger) {
        console.log(new Error().stack.substring(0, 300));
      }
    }
  },
  infoNotify(section, meta, useInProduction = false) {
    if (process.env.REACT_APP_STAGE !== PRODUCTION || useInProduction) {
      bugsnagClient.addMetadata(section, meta);
      bugsnagClient.notify(new Error('"info notify"'));
    }
  },
  infoMainNotify({ nameNotify = 'info notify', section, meta, useInProduction = false }) {
    if (process.env.REACT_APP_STAGE !== PRODUCTION || useInProduction) {
      bugsnagClient.addMetadata(section, meta);
      bugsnagClient.notify(new Error(`${nameNotify}`));
    }
  },
};

export default Logger;
